import * as angular from 'angular';
import * as angularTranslate from 'angular-translate';

import { ngxAddressDetailsFormModule } from '@go-modules/components/payment-panel/address-details-form';
import { licenseDetailsFormModule } from 'go-modules/payment-panel/license-details-form';
import { ngxProductDetailsFormModule } from '@go-modules/components/payment-panel/product-details-form';
import { ngxPayWithCardModule } from '@go-modules/components/payment-panel/pay-with-card';
import { EnterInformationComponent } from './enter-information.component';
import './style.less';


export const enterInformationModule = angular.module('enterInformationModule', [
	angularTranslate,
	ngxAddressDetailsFormModule,
	licenseDetailsFormModule,
	ngxPayWithCardModule,
	ngxProductDetailsFormModule
])
	.component('enterInformation', EnterInformationComponent)
	.name;
